import { REPUBS } from '~/vendor/cx-modules/constants';

import { FOOTBALL } from './categoryGroupNames';
import {
  EFL_CHAMPIONSHIP,
  EFL_LEAGUE_ONE,
  EFL_LEAGUE_TWO,
  EPL,
  SERIE_A,
  UCL,
  UEL,
  US_MLS,
  WORLD_CUP_26,
} from './constants';

export const EVENT_DISPLAY_NAME = 'eventDisplayName';

export function getEventDisplayNames(repubName: string = REPUBS.OC.name) {
  return {
    [REPUBS.OC.name]: {
      [WORLD_CUP_26]: {
        displayName: 'World Cup',
        categoryGroupName: FOOTBALL,
      },
      [EFL_CHAMPIONSHIP]: {
        displayName: 'Championship',
        categoryGroupName: FOOTBALL,
      },
      [EFL_LEAGUE_ONE]: {
        displayName: 'League One',
        categoryGroupName: FOOTBALL,
      },
      [EFL_LEAGUE_TWO]: {
        displayName: 'League Two',
        categoryGroupName: FOOTBALL,
      },
      [EPL]: {
        displayName: 'Premier League',
        categoryGroupName: FOOTBALL,
      },
      [US_MLS]: {
        displayName: 'MLS',
        categoryGroupName: FOOTBALL,
      },
      [UCL]: {
        displayName: 'Champions League',
        categoryGroupName: FOOTBALL,
      },
      [UEL]: {
        displayName: 'Europa League',
        categoryGroupName: FOOTBALL,
      },
      [SERIE_A]: {
        displayName: 'Serie A',
        categoryGroupName: FOOTBALL,
      },
    },
    [REPUBS.US.name]: {
      [WORLD_CUP_26]: {
        displayName: 'World Cup',
        categoryGroupName: FOOTBALL,
      },
      [EFL_CHAMPIONSHIP]: {
        displayName: EFL_CHAMPIONSHIP,
        categoryGroupName: FOOTBALL,
      },
      [EFL_LEAGUE_ONE]: {
        displayName: EFL_LEAGUE_ONE,
        categoryGroupName: FOOTBALL,
      },
      [EFL_LEAGUE_TWO]: {
        displayName: EFL_LEAGUE_TWO,
        categoryGroupName: FOOTBALL,
      },
      [EPL]: {
        displayName: EPL,
        categoryGroupName: FOOTBALL,
      },
      [US_MLS]: {
        displayName: 'MLS',
        categoryGroupName: FOOTBALL,
      },
      [UCL]: {
        displayName: 'Champions League',
        categoryGroupName: FOOTBALL,
      },
      [UEL]: {
        displayName: 'Europa League',
        categoryGroupName: FOOTBALL,
      },
      [SERIE_A]: {
        displayName: SERIE_A,
        categoryGroupName: FOOTBALL,
      },
    },
    [REPUBS.WS.name]: {
      [WORLD_CUP_26]: {
        displayName: 'World Cup',
        categoryGroupName: FOOTBALL,
      },
      [EFL_CHAMPIONSHIP]: {
        displayName: 'Championship',
        categoryGroupName: FOOTBALL,
      },
      [EFL_LEAGUE_ONE]: {
        displayName: 'League One',
        categoryGroupName: FOOTBALL,
      },
      [EFL_LEAGUE_TWO]: {
        displayName: 'League Two',
        categoryGroupName: FOOTBALL,
      },
      [EPL]: {
        displayName: 'Premier League',
        categoryGroupName: FOOTBALL,
      },
      [US_MLS]: {
        displayName: 'MLS',
        categoryGroupName: FOOTBALL,
      },
      [UCL]: {
        displayName: 'Champions League',
        categoryGroupName: FOOTBALL,
      },
      [UEL]: {
        displayName: 'Europa League',
        categoryGroupName: FOOTBALL,
      },
      [SERIE_A]: {
        displayName: 'Serie A',
        categoryGroupName: FOOTBALL,
      },
    },
    [REPUBS.GZ.name]: {
      [WORLD_CUP_26]: {
        displayName: 'Coppa Del Mondo',
        categoryGroupName: FOOTBALL,
      },
      [SERIE_A]: {
        displayName: 'Serie A',
        categoryGroupName: FOOTBALL,
      },
      [EFL_CHAMPIONSHIP]: {
        displayName: 'Championship',
        categoryGroupName: FOOTBALL,
      },
      [EFL_LEAGUE_ONE]: {
        displayName: 'League One',
        categoryGroupName: FOOTBALL,
      },
      [EFL_LEAGUE_TWO]: {
        displayName: 'League Two',
        categoryGroupName: FOOTBALL,
      },
      [EPL]: {
        displayName: 'Premier League',
        categoryGroupName: FOOTBALL,
      },
      [US_MLS]: {
        displayName: 'MLS',
        categoryGroupName: FOOTBALL,
      },
      [UCL]: {
        displayName: 'Champions League',
        categoryGroupName: FOOTBALL,
      },
      [UEL]: {
        displayName: 'Europa League',
        categoryGroupName: FOOTBALL,
      },
    },
  }[repubName];
}
